import { useEffect, useRef, useState } from 'react';

import { useAuthenticationDataContext } from '../../Helpers/AuthenticationDataProvider';
import { RC_DOMAIN } from '../../Helpers/EnvVars';

import { Props, TabStatus } from './RocketChat.model';

const useRocketChat = ({ roomId, updateChatStatus }: Props) => {
	const iFrameRef = useRef<HTMLIFrameElement>(null);

	const { isRocketIframeAuthenticated, rocketAuthToken, setIsRocketIframeAuthenticated} = useAuthenticationDataContext();
	let timer: ReturnType<typeof setTimeout>;

	useEffect(() => {
		updateChatStatus(TabStatus.Loading);
		timer = setTimeout(() => { updateChatStatus(TabStatus.Loaded) }, 5000);
	}, [roomId]);

  const onLoadIframe = (event: any) => {

		if (iFrameRef && iFrameRef.current && iFrameRef.current.contentWindow) {
			iFrameRef.current.contentWindow.postMessage({
				externalCommand: 'login-with-token',
				token: rocketAuthToken
			}, RC_DOMAIN );

			if (!isRocketIframeAuthenticated) {
				setIsRocketIframeAuthenticated(true);
			}
		}

		window.addEventListener('message', function(e) {
			// if (e.data.eventName === 'new-message' && e.data.data.msg.includes("started a call" )) {
			// 	setShowJoinCall(true);
			// }

			if (e.data.eventName === 'Custom_Script_Logged_In') {
				clearTimeout(timer);
				timer = setTimeout(() => {
					updateChatStatus(TabStatus.Loaded);
				}, 1000);
			}

			if (e.data.eventName === 'Custom_Script_Logged_Out') {
				clearTimeout(timer);
				timer = setTimeout(() => {
					updateChatStatus(TabStatus.Error)
				}, 2000);
			}
		});
	}
	
	return {
		iFrameRef,
		isRocketIframeAuthenticated,
		onLoadIframe,
	}
}

export default useRocketChat;